import { BasketItem } from "./BasketItem";
import { BasketItemType } from "./BasketItemType";
import { RawBasketItem } from "./RawBasketItem";
import { RawSaleBasketItem } from "./RawSaleBasketItem";


export class SaleBasketItem extends BasketItem
{
    public Type = BasketItemType.Sale;
    
    constructor(raw: Partial<RawSaleBasketItem>)
    {
        super(raw);
    }

    public get AsString(): string
    {
        return `Sprzedaż: ${this.ProductInfo.Name} (${this.Option.Name || "opcja domyślna"}) x${this.Quantity.value}`;
    }

    public get AsRaw(): RawBasketItem
    {
        return ({
            ...super.AsRaw,
        } as RawSaleBasketItem);
    }
}
